import { getUrlParameterByName } from './url-service';
import { THEME_URL_PARAMS } from '../constants/theme-config-constants';

let CONFIG;

function initConfig() {
    CONFIG = Object.entries(THEME_URL_PARAMS).reduce((acc, [key, param]) => {
        acc[key] = getUrlParameterByName(param);
        return acc;
    }, {});
}

initConfig();

export { CONFIG };
